import { MeetingDetail } from '../models/meeting-detail.model';
import moment from 'moment';
import { Injectable } from '@angular/core';

import { CommonService } from './../services/common.service';
import { GlobalConstants } from './../global-constants';
import { MeetingScheduler, MeetingDragDropModel, MeetingSchedulerData } from './../models/meeting-dragdrop.model';
import { MeetingTypeList } from './../models/meeting-type-model.model';
import { Constants } from './../constants';

@Injectable({
    providedIn: 'root'
})

export class MeetingMapping {
    constructor(private commonService: CommonService,
        private globalConstants: GlobalConstants,
        private constants: Constants) {

    }

    public mapMeetingDetail(responseData: any): MeetingDetail {
        const meetingDetails = {
            meetingDate: responseData.meetingDate,
            meetingAttendees: responseData.meetingAttendees(),
            meetingDescription: responseData.meetingDescription(),
            meetingEndTime: responseData.meetingEndTime,
            meetingLocation: responseData.meetingLocation,
            meetingStartTime: responseData.meetingStartTime,
            meetingTitle: responseData.meetingTitle,
        };
        return meetingDetails;

    }

    updateMeetingScheduler(meeting: MeetingScheduler): MeetingDragDropModel {
        const meetingDragDrop: MeetingDragDropModel = {
            meetingId: meeting.data.id,
            recurringId: meeting.data.recurringId,
            startDate: moment(meeting.start).format(this.globalConstants.format.date),
            endDate: moment(meeting.end).format(this.globalConstants.format.date),
            startTime: moment(meeting.start).format(this.globalConstants.format.time),
            endTime: moment(meeting.end).format(this.globalConstants.format.time),
            actualStartDate: moment(meeting.data.actualStartDate).format(this.globalConstants.format.date),
            actualEndDate: moment(meeting.data.actualEndDate).format(this.globalConstants.format.date),
            occuranceType: meeting.data.occuranceType,
        };
        return meetingDragDrop;
    }

    setMeetingScheduler(meetingList: any): Array<MeetingScheduler> {
        const schedulerMeetings: Array<MeetingScheduler> = [];
        const dateFormat = this.globalConstants.format.date;
        if (meetingList) {
            meetingList.forEach((element: any) => {
                const meeting = new MeetingScheduler();
                meeting.title = element.meetingTitle;
                meeting.start = moment(this.commonService.getDate(element.startDateTime, dateFormat) + ' ' + element.startTime).toDate();
                meeting.end = moment(this.commonService.getDate(element.endDateTime, dateFormat) + ' ' + element.endTime).toDate();
                meeting.backgroundColor = element.meetingTypeBackgroundColor,
                    // this.commonService.getLightenColor(element.meetingTypeColor, 20);
                    meeting.borderColor = element.meetingTypeColor;
                meeting.textColor = this.commonService.getFontColor(meeting.backgroundColor);
                meeting.icon = 'event';
                meeting.data = this.setMeetingSchedulerData(element);
                meeting.allDay = false;
                if (element.adjourned === true) {
                    meeting.title = 'CANCELLED ' + meeting.title;
                }
                meeting.editable = false; // to disable D&D and resizing of meeting
                meeting.agendaPosted = element.agendaStatus === this.constants.agendaItemStatus.posted
                meeting.minutesPosted = element.minutesStatus === this.constants.minutesStatus.posted
                meeting.videoPosted = this.commonService.videoStatusAvailable(element.videoStatus)
                schedulerMeetings.push(meeting);
            });
        }
        return schedulerMeetings.sort((first, second) => {
            const startTimeDifference = first.start.getTime() - second.start.getTime();
            if (startTimeDifference !== 0) {
                return startTimeDifference;
            }

            return first.data.id - second.data.id;
        });

    }

    setMeetingSchedulerData(element: any): MeetingSchedulerData {
        const dateFormat = this.globalConstants.format.date;
        const meetingData: MeetingSchedulerData = {
            actualEndDate: element.actualEndDate,
            actualStartDate: element.actualStartDate,
            endTime: element.endTime,
            location: element.location,
            recurringId: element.recurringId,
            startTime: element.startTime,
            recurringType: element.recurringType,
            id: element.meetingId,
            isAdjourned: element.adjourned,
            occuranceType: 0,
            startDate: this.commonService.getDate(element.startDateTime, dateFormat),
            enddDate: this.commonService.getDate(element.endDateTime, dateFormat),
        };
        return meetingData;
    }

    public getMeetingTypeList(responseData: any): Array<MeetingTypeList> {
        const meetingTypeList: Array<MeetingTypeList> = [];
        const seenMeetingTypeIds = new Set<number>();
        responseData.forEach((data: any) => {
            const meetingTypeId = Number(data.meetingTypeId);
            if (seenMeetingTypeIds.has(meetingTypeId)) {
                return;
            }
            seenMeetingTypeIds.add(meetingTypeId);
            const meetingType = {
                title: data.meetingTypeTitle,
                id: meetingTypeId,
                colorHexCode: data.meetingTypeColor,
                selected: true,
                meetings: []
            };
            meetingTypeList.push(meetingType);
        });
        return meetingTypeList;

    }

}
